<template>
  <div class="activity-info">
    <h2 class="title">{{ title }}</h2>
    <div class="intro">
      <p class="icon" data-type="photo">{{ total }}</p>
      <p class="icon" data-type="viewer">{{ pv }}</p>
      <button class="details-button" v-on:click="showDetails">{{$t("activityInfo.detail")}}</button>
    </div>
    <div class="full-screen" :data-is-hide="!isShowingDetails" ref="fullScreen">
      <div class="header">
        <button data-type="close" v-on:click="hideDetails"><i class="glyphicon glyphicon-remove"></i></button>
      </div>
      <banner :src="src" style="margin-top: 4.4rem"/>
      <h2 class="title">{{ title }}</h2>
      <div v-if="details" class="details">
        <p v-for="detail in details.split('\n')">{{ detail }}<br/></p>
      </div>
    </div>
  </div>
</template>

<script>
import banner from './banner.vue'
import { show, hide } from '@/assets/js/methods/fullscreen.js'

export default {
  data: () => ({
    isShowingDetails: false
  }),
  props: {
    title: String,
    total: Number,
    pv: Number,
    details: String,
    src: String
  },
  components: {
    banner
  },
  methods: {
    showDetails () {
      show(this.$refs.fullScreen)
      this.isShowingDetails = true
      console.log(this.details)
    },
    hideDetails () {
      hide(this.$refs.fullScreen)
      this.isShowingDetails = false
    }
  }
}
</script>
